import {
    temAcesso
} from '@/shared/auth/temAcesso'

const RegrasAcesso = () => import('./RegrasAcesso')
const RegrasAcessoForm = () => import('./RegrasAcessoForm')

export default {
    path: 'regrasacesso',
    name: 'RegrasAcesso',
    component: RegrasAcesso,
    beforeEnter: (to, from, next) => {
        if (temAcesso('CTRLACS-RA-00')) {
            next()
        }
    },
    children: [{
            path: 'inserir',
            name: 'RegrasAcesso_Inserir',
            component: RegrasAcessoForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CTRLACS-RA-01')) {
                    next()
                }
            }
        },
        {
            path: 'detalhar/:id',
            name: 'RegrasAcesso_Detalhar',
            component: RegrasAcessoForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CTRLACS-RA-02')) {
                    next()
                }
            }
        },
        {
            path: 'atualizar/:id',
            name: 'RegrasAcesso_Atualizar',
            component: RegrasAcessoForm,
            beforeEnter: (to, from, next) => {
                if (temAcesso('CTRLACS-RA-03')) {
                    next()
                }
            }
        }
    ]
}
